import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'jquery';
import { BehaviorSubject } from 'rxjs';
import 'signalr';
import { environment } from 'src/environments/environment';
declare var $: any;
@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private connection: any;
  private proxy: any;
  alertsSource: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  alerts = this.alertsSource.asObservable();
  constructor(private http: HttpClient) { }
  /**
   * connection to signalR hub
   */
  public initializeAlertsSignalRConnection(): void {
    let signalRServerEndPoint = `${environment.signalRUrl}`;
    this.connection = $.hubConnection(signalRServerEndPoint);
    this.connection.qs = { 'applicationName': 'Mylion' };

    this.proxy = this.connection.createHubProxy('alertsHub');
    this.proxy.on('alertdata', (alerts) => {
      this.alertsSource.next(alerts);
    });

    this.connection.start().done((data: any) => {
      console.log('SignalR connection established...');
      this.getAlerts().subscribe();
    }).catch((error: any) => {
      console.log('Alerts hub error -> ' + error);
    });
  }
  /**
   * API call to get alerts continuously
   * @returns alerts
   */
  private getAlerts = () => {
    return this.http.get(`signalr://api/Alert?appName=Mylion&title=''&companyId=0&connectionId=${(this.connection.id)}`);
  }
}
